/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Machine-readable skip reason
 */
export type PopulateSimilarSkipReason = (typeof PopulateSimilarSkipReason)[keyof typeof PopulateSimilarSkipReason];

export const PopulateSimilarSkipReason = {
  DATAPOINT_NOT_ENABLED: 'datapoint_not_enabled',
  EXISTING_RULE: 'existing_rule',
  EXISTING_SYSTEM_RULE: 'existing_system_rule',
  ADMIN_DISABLED_RULE: 'admin_disabled_rule',
  HIDDEN_SYSTEM_MODEL: 'hidden_system_model',
} as const;
